import { render } from "./SearchBarHeaderComponent.vue?vue&type=template&id=a6153364&scoped=true"
import script from "./SearchBarHeaderComponent.vue?vue&type=script&lang=js"
export * from "./SearchBarHeaderComponent.vue?vue&type=script&lang=js"

import "./SearchBarHeaderComponent.vue?vue&type=style&index=0&id=a6153364&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6153364"]])

export default __exports__